export const disciplineOptions = [ 
    { value: 0, label: "None" }, 
    { value: 1, label: "Physical Therapist (PT)" }, 
    { value: 2, label: "Physical Therapist Assistant (PTA)" }, 
    { value: 3, label: "Occupational Therapist (OT)" }, 
    { value: 4, label: "Certified Occupational Therapy Assistant (COTA)" }, 
    { value: 5, label: "Developmental Therapist (DT)" }, 
    { value: 6, label: "Developmental Therapy Consultant (DTC)" }, 
    { value: 7, label: "Speech-Language Pathologist (SLP)" }, 
    { value: 8, label: "Speech-Language Pathologist Clinical Fellow (SLPCF)" }, 
    { value: 9, label: "Registered Nurse (RN)" }, 
    { value: 10, label: "Social Worker (SW)" }, 
    { value: 11, label: "Behavioralist (BEH)" }, 
    { value: 12, label: "Psychologist (PSY)" }, 
    { value: 13, label: "Student" } ];

export const frequencyOptions = [
    { value: 0, label: "1 x Month" },
    { value: 1, label: "2 x Month" },
    { value: 2, label: "1 x Week" },
    { value: 3, label: "1 x Quarter" },
    { value: 4, label: "1 x Only" },
    { value: 5, label: "Every Other Week"}
]

export const frequencyMinutes = [
    { value: 0, label: '0 Minutes'},
    { value: 30, label: "30 Minute"},
    { value: 45, label: "45 Minutes"},
    { value: 60, label: "60 Minutes"},
    { value: 90, label: "90 Minutes"}
]